import request from '@/utils/request'
import URL from './urlTranslator'

// 获取空运港口列表
export function getAirPortList(params) {
  return request({
    url: URL.mdm.airport.port,
    method: 'get',
    params
  })
}

// 获取基础港口
export function loadTemplatePort(likeName) {
  const params = { likeName }
  return request({
    url: URL.mdm.airport.templatePortList,
    method: 'get',
    params
  })
}

// 租户新增基础港口
export function addTemplatePort2Tenant(data) {
  return request({
    url: URL.mdm.airport.addTenantPort,
    method: 'post',
    data
  })
}

// 平台新增基础港口
export function addPlatformPort(data) {
  return request({
    url: URL.mdm.airport.addPlatformPort,
    method: 'post',
    data
  })
}

// 编辑空运港口
export function updateAirPort(data) {
  return request({
    url: URL.mdm.airport.port,
    method: 'put',
    data
  })
}

// 批量删除空运港口
export function batchDelAirPort(uuidList) {
  const data = [...uuidList]
  return request({
    url: URL.mdm.airport.port,
    method: 'delete',
    data
  })
}

export function getAirPortByCode(code) {
  return request({
    url: URL.mdm.airport.getAirPortByCode + '/' + code,
    method: 'get'
  })
}

// 获取根据代码、名称模糊查询空运港口amsPort
export function getAirAmsPortList(params) {
  return request({
    url: URL.mdm.airport.amsPort,
    method: 'get',
    params
  })
}

// 获取空运所有amsPort
export function getAirAllAmsPort() {
  return request({
    url: URL.mdm.airport.getAllAmsPort,
    method: 'get'
  })
}

// 获取uuid删除海运港口amsPort
export function deleteAirAmsPort(uuid) {
  return request({
    url: `${URL.mdm.airport.amsPort}/${uuid}`,
    method: 'delete'
  })
}

// 获取uuid删除海运港口amsPort
export function addAirAmsPort(data) {
  return request({
    url: `${URL.mdm.airport.amsPort}`,
    method: 'post',
    data
  })
}

// 获取uuid删除海运港口amsPort
export function editAirAmsPort(data) {
  return request({
    url: `${URL.mdm.airport.amsPort}`,
    method: 'put',
    data
  })
}

// 批量更新AmsPort状态
export function batchUpdateAmsPortStatus(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: `${URL.mdm.airport.batchUpdateAmsPortStatus}`,
    method: 'put',
    data
  })
}

// 获取航空公司列表
export function getAirlineList(data) {
  return request({
    url: `${URL.mdm.airport.getAirlineList}`,
    method: 'post',
    data
  })
}

// 新增航空公司
export function addAirline(data) {
  return request({
    url: `${URL.mdm.airport.addAirline}`,
    method: 'post',
    data
  })
}

// 编辑航空公司
export function updateAirline(data) {
  return request({
    url: `${URL.mdm.airport.updateAirline}`,
    method: 'post',
    data
  })
}

// 删除航空公司
export function deleteAirline(data) {
  return request({
    url: `${URL.mdm.airport.deleteAirline}`,
    method: 'post',
    data
  })
}

// 获取所有航空公司代码
export function getAllAirline() {
  return request({
    url: `${URL.mdm.airport.getAllAirline}`,
    method: 'get'
  })
}
